import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './ResultsSection.css';

const stats = [
  { label: "YEARS IN BUSINESS ", number: "+5" },
  { label: "Imaginarees on board ", number: "100" },
  { label: "Digital solutions delivered ", number: "+300" },
  { label: "Project extensions ", number: "9/10" }
];

const ResultsSection = () => {
  const cardRefs = useRef([]);
  const isMobile = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkMobile = () => {
      isMobile.current = window.innerWidth <= 768;
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    if (!isMobile.current) {
      const handleScroll = () => {
        const scrollY = window.scrollY;

        cardRefs.current.forEach((ref, index) => {
          if (!ref) return;
          const wave = Math.sin(scrollY * 0.01 + index * 0.8) * 20;
          ref.style.transform = `translateY(${wave}px)`;
        });
      };

      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', checkMobile);
      };
    }

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  return (
    <section className="results-section">
      <div className="results-container">
        <h2 className="results-heading">Tangible results right on time</h2>
        <div className="results-stats">
          {stats.map((item, index) => (
            <div
              key={index}
              ref={(el) => (cardRefs.current[index] = el)}
              className="results-card"
            >
              <p className="results-label">{item.label}</p>
              <div className="results-number">{item.number}</div>
            </div>
          ))}
        </div>
        <button
          type="button"
          className="results-btn"
          onClick={() => navigate('/company/about-us')}
        >
          ABOUT US
        </button>
      </div>
    </section>
  );
};

export default ResultsSection;
